// extracted by mini-css-extract-plugin
export default {"Title":"cardsystem_Title__ojx5c","Content":"cardsystem_Content__wbcTq","Image":"cardsystem_Image__XRsjG","Link":"cardsystem_Link__iPRJP"};